import { render, staticRenderFns } from "./AluminiStudentView.vue?vue&type=template&id=fd2a138a&scoped=true&"
import script from "./AluminiStudentView.vue?vue&type=script&lang=js&"
export * from "./AluminiStudentView.vue?vue&type=script&lang=js&"
import style0 from "./AluminiStudentView.vue?vue&type=style&index=0&id=fd2a138a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd2a138a",
  null
  
)

export default component.exports